import styled from 'styled-components';
import colors from '_colors.module.scss';
import { BdsGrid } from 'blip-ds/dist/blip-ds-react';

export const ModalContent = styled(BdsGrid)`
  width: 536px;
`;

export const Subtitle = styled.div`
  bds-typo {
    color: ${colors.ContentDisable};
  }
`;
